import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, IconButton, Tooltip, InputAdornment,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';

import { selectAllVisitors, selectAllCompanies, selectAllEmails, selectAllPhoneDispalys }
from '../../store/visitorSlice';

import accessLogService from '../../services/accessLogService'

import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllFloors,
}  from '../../store/floorSlice'


import { selectAllHosts } from '../../store/userSlice';



import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
//import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
//import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';


import { format, set } from 'date-fns';

import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
 

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import { selectAllReasons } from '../../store/reasonSlice';

import { generatePhoneDetail } from '../../utils/phoneUtil';



const VisitorAccessLogPage = ({group, action, visitor_id, invitation_id}) => {

  const navigate = useNavigate()
  
  const {userInfo} = useAppAuthContext()
  
  const managedHosts = useSelector(selectAllHosts)

  const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


  const dispatch = useDispatch()
  const floors = useSelector(selectAllFloors)
  const visit_reasons = useSelector(selectAllReasons)
  const allEmails = useSelector(selectAllEmails)
  const allPhones = useSelector(selectAllPhoneDispalys)
  const allCompanies = useSelector(selectAllCompanies)

  const [host, setHost] = React.useState('');
  const [name, setName] = React.useState('');
  const [phone, setPhone] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [company, setCompany] = React.useState('');


  
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [reason, setReason] = React.useState('');

  const [floor, setFloor] = useState('');
  
  const [queryClicked, setQueryClicked] = React.useState(true);
  const [tableData, setTableData] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchCriteria, setSearchCriteria] = React.useState({});
  const [endDateTimeError, setEndDateTimeError] = useState(''); 

  const fetcPagedhData = async(searchCriteria)=>{
    setStatus('processing')
    try
    {
      let response = await accessLogService.queryVisitorAccessLog(searchCriteria)
    
      let data = response.data;
      console.log(data)
      if (data.content)
      {
          data.content.forEach(generatePhoneDetail)
      }

      setTableData(data.content)
      setTotalRecords(data.totalElements)
      setStatus('success')

    }
    catch (ex)
    {
      setStatus('error')
      setErrorMessage("Network retrival error")
    }

  }
  
  useEffect(() => {
    setAppTitle(  ['Transaction Log','Visitor Entry Log'])
    setErrorMessage('')
    setErrorTitle('')

    if (queryClicked)
    {
        let x={...searchCriteria, pageSize,pageNumber}  
        fetcPagedhData(x);

    }
  }, [searchCriteria, pageNumber, pageSize, queryClicked])

  const doReset = ()=>
  {
      setHost('')
      setName('')
      setPhone('')
      setEmail('')
      setCompany('')
      setFloor('')
      setEndDateTimeError('')
      setStartDateTime(null)
      setReason('')
      setEndDateTime(null)
      setQueryClicked(false)
      setSearchCriteria({})
      setTableData([])
      setTotalRecords(0)
  }
 
  const doSearch = async ()=>
  {
      let errNo=0
      let tmp1 = Date.parse(startDateTime);
      let tmp2 = Date.parse(endDateTime);


      if (!isNaN(tmp2) && !isNaN(tmp1) && tmp2<tmp1 )
        {
          errNo++;
          setEndDateTimeError('End Time cannot be earlier than Start Time')    
            
        }     

        let phone1 = phone ? phone.trim():''
        phone1 = phone1.replace(' ','-')
  

      let postBody={
          name,
          email,
          phone:phone1,
          company,
          floor:floor,

          pageNumber,
          pageSize,
          host,
          reason,

      }



      let dt1 = null;
      let dt2=null
      if (!isNaN(tmp1))
      {
          dt1=new Date(startDateTime.getFullYear(), startDateTime.getMonth(),startDateTime.getDate())
          tmp1=dt1.getTime();
          postBody.startTm=format(dt1, "yyyy-MM-dd'T'HH:mm:ss.SSS");
          
          
      }
      if (!isNaN(tmp2))
      {
          dt2=new Date(endDateTime.getFullYear(), endDateTime.getMonth(),endDateTime.getDate(), 23, 59,59,999)
          //alert(dt2)
          tmp2=dt2.getTime();
          //postBody.endTm=dt2.toISOString();
      
          postBody.endTm=format(dt2, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      }

      //alert(JSON.stringify(postBody))


      if (!isNaN(tmp1)  && !isNaN(tmp2) && tmp2 <tmp1 )
      {
        console.log("Invalid Date Range")  

      }
      console.log(startDateTime)

      console.log(dt1)
      console.log(dt2)

      
      
      console.log("xx-"+tmp1)
      console.log(tmp2)
      
      if (errNo>0) return
      
      setQueryClicked(true)
      setSearchCriteria(postBody)
      
  }

  const handleChangePage = (event, newPage) => {
    //alert('New Page--'+newPage)
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    //alert('New Page Size--'+event.target.value)
    setPageNumber(0);
  };

  return (
    <Box sx={{p:1}}>
      
        <Card sx={{mX:1, mb:0, px:1, pt:2, pb:0}} raised>
        <CardContent sx={{my:0, py:0}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={20}

          >
       
          <Grid item xs={20} sm={10}  lg={4}  md={4}  sx={{/*bgcolor:{lg:'red', xl:'green', md:'yellow'}*/}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker 
                       disableFuture
                      label="Start Date"
                      onChange={(newValue) => {  setStartDateTime(newValue);}}
                      value={startDateTime}
                      inputFormat="dd/MM/yyyy"

                      renderInput={(props) => 
                      <TextField {...props} 
                           
                          fullWidth 
                          size='small'
                          />}
                      
                      />
                  </LocalizationProvider>
             </Grid>
              <Grid item xs={20} sm={10}  lg={4}  md={4} >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker 
                      inputFormat="dd/MM/yyyy"
                      disableFuture
                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          size='small'
                          fullWidth 
                          error={Boolean(endDateTimeError)}
                      helperText={Boolean(endDateTimeError)? endDateTimeError : '' }
                          />}
                      label="End Date"
                      value={endDateTime}
                      onChange={(newValue) => {  setEndDateTime(newValue);}}
                  />
                  </LocalizationProvider>
              </Grid>
          

              {
                  userInfo.idTokenClaims.roles.includes('ADMIN') &&
                  <Grid item xs={20} sm={10}  lg={4}  md={4} >
                  <FormControl   fullWidth size='small'>
                    <InputLabel id="id_host_label" >Host</InputLabel>
                        <Select
                            
                            labelId="id_host_label"
                            id="id_host"
                            value={host}
                            label="Host"
                            onChange={(e)=>setHost(e.target.value)}
                            
                            >
                          <MenuItem value={''}>ALL</MenuItem>
                          {
                              managedHosts && managedHosts.map( (u)=>
                              <MenuItem key={u.userName} value={u.userName}>{u.fullName}</MenuItem>
                              )
                          }
                      </Select>
                                
                    </FormControl>
              
            </Grid>


              }
            <Grid item xs={20} sm={10}  lg={4}  md={4} >
                    
                    {/* <TextField 
                          size='small'
                            fullWidth  variant='outlined'
                        value={reason}
                        onChange={e=>setReason(e.target.value)}
                        id="id_reason"
                        label='Purpose'
                      
                      /> */}
                        <Autocomplete 
                      fullWidth
                      size='small'
                      // freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_reason" 
                      value={reason}
                      options={visit_reasons.map((option) => option.reason)} 
                      onChange = { (e, newValue)=>{setReason(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            // onChange = { e=>{setSubject(e.target.value);}}
                            label="Purpose"  
                            //inputProps={{ maxLength: 100, minLength:5 }}
                            //helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Subject for the visit"}
                            />}

                      />
                </Grid>
    
              <Grid item xs={20} sm={10}  lg={4}  md={4} >
                  <FormControl   fullWidth size='small'>
                    <InputLabel id="id_floor_label" >Floor</InputLabel>
                        <Select
                            
                            labelId="id_floor_label"
                            id="id_floor"
                            value={floor}
                            label="Floor"
                            onChange={(e)=>setFloor(e.target.value)}
                            
                            > 
                              <MenuItem value={''}>ALL</MenuItem>
                          
                          
                          {
                              floors.map( (ct)=>
                                (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                              )
                          }
                          
                      </Select>
                                
                    </FormControl>
              
            </Grid>
            <Grid item xs={20} sm={10}  lg={4}  md={4} >
                    
                <TextField 
                      size='small'
                        fullWidth  variant='outlined'
                    value={name}
                    onChange={e=>setName(e.target.value)}
                    id="id_name"
                    label="Visitor's Name"
                  
                  />
            </Grid>
      
            <Grid item xs={20} sm={10}  lg={4}  md={4} >
              <Autocomplete 
                    fullWidth

                    forcePopupIcon={false}
                    freeSolo
                    size='small'
                    id="id_phone" 
                    
                    value={phone}
                    options={allPhones} 
                    onChange = { (e, newValue)=>{setPhone(newValue);  } }
                    renderInput={(params) => 
                        <TextField {...params} 
                          
                          onChange = { e=>{setPhone(e.target.value);}}
                          label="Visitor's Phone Number"  
                          
                          />}

                    />
            
          </Grid>

          <Grid item xs={20} sm={10}  lg={4}  md={4} >
            
            <Autocomplete 
                fullWidth
                
                freeSolo
                size='small'
                // selectOnFocus
                // handleHomeEndKeys
                // //disableClearable
                id="id_email" 
                
                value={email}
                
                options={allEmails} 
                //onChange = { (e, newValue)=>{;   } }
                onChange = { (e, newValue)=>{setEmail(newValue);}}
                renderInput={(params) => 
                    <TextField {...params} 
                      
                      onChange = { e=>{setEmail(e.target.value);}}
                      
                      label="Visitor's Email"  
                      //inputProps={{ maxLength: 100, minLength:5 }}
                      />}

                />
          </Grid>
          <Grid item xs={20} sm={10} lg={4} md={4} sx={{  }}>
             <Autocomplete 
                fullWidth
                freeSolo
                size='small'
                id="id_company" 
                
                value={company}
                options={allCompanies} 
                //onChange = { (e, newValue)=>{;   } }
                onChange = { (e, newValue)=>{setCompany(newValue);}}
                renderInput={(params) => 
                    <TextField {...params} 
                      onChange = { e=>{setCompany(e.target.value);}}
                      label="Visitor's Organization"  
                      />}
                />
          </Grid>   
         
          <Grid item xs={20} sm={10} md={4} lg={4} >
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-around'}}>

                  <Button variant="outlined"  color='primary'  
                    onClick={doSearch}
                  > Search</Button>
                  <Button variant="outlined"  color='info'  
                    onClick={doReset}
                  > Clear</Button>

              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
        <Box sx={{mx:0,mt:1}}>
          <TableContainer component={Paper} >
            <Table aria-label="collapsible table" size='small' >
            <TableHead>
                <TableRow sx={{bgcolor:'#6495ED'}}>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>NAME</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>EMAIL</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>PHONE</TableCell>

                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>HOST</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ACTION</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ORGANIZATION</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>PURPOSE</TableCell>
                    <TableCell align="center"  style={{border: '1px solid LightGray', fontWeight: 600}}>FLOOR</TableCell>
                    <TableCell align="center"  style={{border: '1px solid LightGray', fontWeight: 600}}>DATETIME</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  { tableData && tableData.length>0 &&
                      tableData.map((row, i)=>

                        <TableRow key={row.id} 
                            >
      
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.name}
                              </TableCell>
      
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.email}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.phoneDisplay}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.host}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.action}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.company}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.reason}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                
                                  {
                                    row.floor
                                  }
                                  
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.actionTm}
                              </TableCell>

                        </TableRow>

                      )

                  }

              </TableBody>
      
      
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
       
        // backIconButtonProps={{
        //   color: "secondary"
        // }}
        // nextIconButtonProps={{ color: "secondary" }}
        // SelectProps={{
        //   inputProps: {
        //     "aria-label": "page number"
        //   }
        // }}        
        
        showFirstButton={true}
        showLastButton={true}
              count={totalRecords}
              rowsPerPage={pageSize}
              page={pageNumber}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              //ActionsComponent={TablePaginationActions}
      />
       </Box>

       
      
</Box>
      
    
  );
};


export default VisitorAccessLogPage;
